import { Button } from '@factorialco/deprecated-design-system'
import {
  DefaultComplianceSettingsDeleteModalQueryDocument,
  DeleteDefaultComplianceSettingDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const DefaultComplianceSettingsDeleteModal = ({
  isOpen,
  onClose,
  refetchQuery,
  defaultComplianceExtraFieldSettingId,
}: {
  isOpen: boolean
  onClose: () => void
  refetchQuery?: string
  defaultComplianceExtraFieldSettingId: number
}) => {
  const { data, loading } = useQuery(DefaultComplianceSettingsDeleteModalQueryDocument, {
    variables: {
      id: defaultComplianceExtraFieldSettingId,
    },
  })

  const defaultComplianceExtraFieldSetting = data?.finance?.complianceExtraFieldDefaultSetting

  const [deleteDefaultComplianceSetting, { loading: deleting }] = useMutation(
    DeleteDefaultComplianceSettingDocument,
    {
      extractorFn: (data) => data.financeMutations.deleteFinanceComplianceExtraFieldDefaultSetting,
      refetchQueries: refetchQuery ? [refetchQuery] : undefined,
    }
  )

  const onSubmit = async () => {
    const result = await deleteDefaultComplianceSetting({
      variables: {
        id: defaultComplianceExtraFieldSettingId,
      },
    })

    const handled = handleResult(result, (parsedErrors) => {
      app.setFlash({
        type: 'wrong',
        message: parsedErrors.errors ?? i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.compliance_extra_field_default_settings.modal.delete.success'),
      })
      onClose()
    }
  }

  if (!isOpen || (!defaultComplianceExtraFieldSetting && !loading)) return null

  return (
    <Modal
      illustration="template"
      title={i18n.t('finance.compliance_extra_field_default_settings.modal.delete.title')}
      description={i18n.t(
        'finance.compliance_extra_field_default_settings.modal.delete.description',
        {
          taxAgency: (defaultComplianceExtraFieldSetting?.organization ?? '').toUpperCase() ?? '',
          legalEntity: defaultComplianceExtraFieldSetting?.legalEntity?.legalName ?? '',
        }
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={deleting}>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    />
  )
}
